import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/organisations/{organisationId}/remuneration-policy-settings").GET();

export type GetRemunerationPolicyReq = typeof endpoint.types.P;
export type GetRemunerationPolicyRes = typeof endpoint.types.Res;

export async function getRemunerationPolicy(req: GetRemunerationPolicyReq) {
    const call = createCall(endpoint, (r) => fetch(withAccountOrNetworkAuthHeaders(r)));
    return await call({ params: { organisationId: req.organisationId } });
}
